import React, { useEffect, useState } from "react";
import Sidebar from "../components/Sidebar";
import Header from "../components/Header";
import DashboardCards from "../components/DashboardCards";
import "../css/Dashboard.css";
import ActivityOverview from "../components/DashboardActivity";
import RevenueChart from "../components/DashboardRevenue";
import TopServiceCard from "../components/DashboardTopServices";
import DashboardServiceList from "../components/Dashboardservices";
import DashboardRecent from "../components/DashboardRecent";
import api from "../api";
import DoctorFilterComponent from "../components/Dashboardfilter";
import PageTitle from "../components/PageTitleCompoent";
import PawAnimation from "../components/PawAnimation";

export default function Dashboard() {
  const [dashboardData, setDashboardData] = useState(null);
  const [filteredCards, setFilteredCards] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  // Filter states
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");

  // 🔹 Fetch Dashboard Data
  const fetchDashboardData = async (params = {}) => {
    try {
      setLoading(true);

      const res = await api.get("/admin/dashboard/", {
        params, // 👈 backend params
      });

      setDashboardData(res.data);
      setFilteredCards(res.data.dashboard_cards || []);
    } catch (err) {
      console.error("Failed to fetch dashboard data:", err);
      setError("Unable to load dashboard data");
    } finally {
      setLoading(false);
    }
  };

  // 🔹 Initial Load
  useEffect(() => {
    fetchDashboardData();
  }, []);

  // 🔹 Apply Filter
  const handleApplyFilter = (from, to) => {
    const params = {};

    if (from) params.from_date = from; // 👈 send backend key
    if (to) params.to_date = to; // 👈 send backend key

    fetchDashboardData(params);
  };

  if (loading) {
    return <PawAnimation  fullScreen />;
  }

  if (error) {
    return (
      <div className="dashboard-card-container">
        <Sidebar />
        <div className="dashboard-card-main">
          <Header />
          <p className="error">{error}</p>
        </div>
      </div>
    );
  }

  return (
    <div className="dashboard-card-container">
      <Sidebar />
      <div className="dashboard-card-main">
        <Header />

        {/* ---- Title + Filter ---- */}
        <div className="dashboard-filter-header">
          <PageTitle title="Dashboard" />
          {/* <DoctorFilterComponent
            fromDate={fromDate}
            toDate={toDate}
            setFromDate={setFromDate}
            setToDate={setToDate}
            handleApplyFilter={handleApplyFilter}
          /> */}
        </div>

        {/* ---- Filtered Cards ---- */}
        <DashboardCards data={filteredCards} />

        {/* ---- Other Sections ---- */}
        <div className="activity-overview-container">
          <div className="Dashboard-cards1">
            <ActivityOverview
              loading={loading}
              error={error}
              data={dashboardData?.activity_overview}
            />
            <RevenueChart
              revenue={dashboardData?.revenue}
              fromDate={fromDate}
              toDate={toDate}
              setFromDate={setFromDate}
              setToDate={setToDate}
              handleApplyFilter={handleApplyFilter}
            />
          </div>

          <div className="Dashboard-cards2">
            <TopServiceCard data={dashboardData?.top_services} />
            <DashboardServiceList data={dashboardData?.services} />
          </div>
        </div>

        <DashboardRecent data={dashboardData?.recent_orders} />
      </div>
    </div>
  );
}
